@if (isNewNavigationOn) {
  <div class="shell-wrapper">
    @if (!fromAccounts) {
      <div class="shell-wrapper__action-bar"><shell-action-bar /></div>
    }
    <div class="shell-wrapper__container">
      @if (!fromAccounts) {
        <shell-menu [menuItems]="menuItems" [lastUrl]="lastUrl()" />
      }
      <div class="bg-white content h-full w-full shell-borders">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
} @else {
  <ng-container *ngIf="isScreenSmall">
    <treo-vertical-navigation
      class="bg-cool-gray-900 theme-dark"
      [appearance]="'classic'"
      [mode]="'over'"
      [name]="'verticalMainNavigation'"
      [navigation]="menuItems"
      [opened]="false"
    >
      <div treoVerticalNavigationContentHeader>
        <div class="logo">
          <img src="assets/images/logo/ts-intapp-logo.png" />
        </div>
      </div>
    </treo-vertical-navigation>
  </ng-container>
  <div class="wrapper">
    <div #header class="header">
      <div class="logo" *ngIf="!isScreenSmall">
        <img class="logo-text" src="assets/images/logo/ts-intapp-logo.png" />
        <img class="logo-text-on-dark" src="assets/images/logo/logo-text-on-dark.svg" />
        <img class="logo-base" src="assets/images/logo/ts-intapp-logo.png" />
      </div>
      <ng-container *ngIf="!fromAccounts && account.id">
        <div class="main-navigation" #mainNavigation *ngIf="!isScreenSmall">
          <treo-horizontal-navigation
            name="mainNavigation"
            [navigation]="menuItems"
            id="mainNavigation"
          ></treo-horizontal-navigation>
        </div>

        <ts-button
          class="navigation-toggle-button"
          *ngIf="isScreenSmall"
          name="mainNavigation"
          id="mainNavigation"
          [attr.data-testid]="'main-navigation-toggle-vertical-menu-button'"
          type="icon"
          color="basic"
          icon="menu"
          (buttonClick)="toggleNavigation('verticalMainNavigation')"
        ></ts-button>

        <ng-container *ngIf="!isTaskCollaborator">
          <div class="menu-actions">
            <div class="spacer"></div>
            <search [appearance]="'bar'" [account]="account"></search>
            <notifications />
            <calculator></calculator>
            <celeste-toggle [account]="account" />
            <span class="rnw-badge">
              <mat-icon class="cursor-pointer" [fontIcon]="'campaign'"></mat-icon>
            </span>
            <support-hub></support-hub>
          </div>
        </ng-container>
        <user *ngIf="data?.user" [user]="data.user" [isTaskCollaborator]="isTaskCollaborator"></user>
      </ng-container>
    </div>
    <div class="bg-white content">
      <router-outlet *ngIf="true"></router-outlet>
    </div>
  </div>
}
